export default __webpack_public_path__ + "static/media/1_9_hl.1aab2dd3.png";